import React, { useCallback, useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Avatar         from '@material-ui/core/Avatar';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField      from '@material-ui/core/TextField';

import AccountCircle from '@material-ui/icons/AccountCircle';

import Autocomplete from '@material-ui/lab/Autocomplete';

const style = {
  selectingAttender: makeStyles((theme) => ({
    avatar: {
      marginRight: theme.spacing(1),
      height: theme.spacing(3),
      width: theme.spacing(3),
    },
  })),
};

export default function SelectingAttender(props) {
  const classes = style.selectingAttender();

  const [ selectableAttenders, setSelectableAttenders ] = useState([]);

  const {
    request,
    ticketer,
  } = props.context.getStates();

  const fetchSelectableAttenders = useCallback((keywords) => {
    request.postSecurely('/schedule/attenders/selectable', {
      ticketer, keywords
    }, (response) => {
      if ('error' in response) {
        console.error(response);
      } else if ('selectableAttenders' in response) {
        setSelectableAttenders(response.selectableAttenders)
      }
    });
  }, [
    request,
    setSelectableAttenders,
    ticketer,
  ]);

  useEffect(() => {
    fetchSelectableAttenders('');
  }, [fetchSelectableAttenders])

  return (
    <Autocomplete options={selectableAttenders}
      autoHighlight
      getOptionLabel={(attender) => attender.name}
      onChange={(event, value) => {
        props.setSelectedAttender({
          ...props.selectedAttender,
          rowid: value ? value.rowid : -1,
        });
      }}
      renderInput={(params) => (
        <TextField placeholder="새 참가자"
          {...params}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
            startadornment: (
              <InputAdornment position="start">
                <AccountCircle />
              </InputAdornment>
            ),
          }}
          onChange={(event) => { fetchSelectableAttenders(event.target.value); }}
        />
      )}
      renderOption={(attender) => (
        <React.Fragment>
          <Avatar className={classes.avatar}
            src={'data:image/jpeg;base64,' + attender.picture64}
          />{attender.name}
        </React.Fragment>
      )}
    />
  );
}
